import React, { Component } from "react";
import DocsList from "./DocsList";

export class DocsDetails extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("DocsDetails");
    this.state = {
      doclist: []
    }
  }

  componentDidMount() {

  }

  render() {
    let { pencilplus } = imagepaths;
    let { onEdit = (() => ('')) } = this.props;
    return (
      <>
        <div className="container-fluid paper_container mb-4">
          <div className="card profile_card">
            <div className="card-header border-0">
              <h5 className="card-title">Docs Details</h5>
              <button className="edit_btn" onClick={() => onEdit()}>
                <span className="cursor-pointer text-black">
                  <img src={pencilplus} />
                </span>
              </button>
            </div>
            <div className="card-body">
              <ul className="docs_list_ul">
                <DocsList listTitle="Partner 1" />
                <DocsList listTitle="Partner 2" />
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(DocsDetails);
